import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 29.1vw;
  height: 52.591em;
  font-size: 12px;
  background: #fff;
  position: relative;

  .hide {
    display: none;
  }
  
  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .logo-rodape {
    width: 10em;
    position: absolute;
    top: 49.3em;
    left: 1.5em;
  }

  .barra-sup {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
  }

  .barra-sup3 {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
    position: absolute;
    top: 51.45em;
    left: 25.2em;
  }

  .barra-sup2 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    top: 0;
    left: 12em;
    position: absolute;
  }

  .barra-sup4 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    position: absolute;
    top: 51.85em;
    left: 16.19em;
  }

  .header {
    margin-top: -2em;
    padding: 1.6em;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .titulo {
        font-size: 9px;
        color: #5B5A5A;
        font-weight: 600;
      }

      .titulo-data {
        font-size: 9px;
        color: #919191;
      }
    }
  }
  
  .body {
    padding: 0.5em 3em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 40em;

    .mid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      height: 35rem;

      .titulo-orcamento {
        color: #5B5A5A;
        font-size: 18px;
        font-weight: 600;
        margin-top: -1rem;
      }

      .text {
        margin-top: 1em;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 24vw;
        background: #1E4778;
        border-radius: 1rem;
        padding: 1rem 2rem 2rem 2rem;
        
        .titulo-list {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .list {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .align-right {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
          }

          .item-cab {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 0.1rem 0;

            .titulo-cab {
              color: #fff;
              font-size: 12px !important;
              font-weight: 600;
              margin-left: 0rem !important;
            }
          }

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 0.3rem 0;
            border-bottom: 1px dashed #fff;

            .col04 {
              width: 2%;
            }

            .col1 {
              width: 10%;
            }

            .col2 {
              width: 20%;
            }

            .col3 {
              width: 30%;
            }

            .col4 {
              width: 40%;
            }

            .col5 {
              width: 50%;
            }

            .col66 {
              width: 66%;
            }

            .col6 {
              width: 60%;
            }

            .col7 {
              width: 70%;
            }

            .col76 {
              width: 76%;
            }

            .col8 {
              width: 80%;
            }

            .col9 {
              width: 90%;
            }

            .img-check {
              width: 0.5rem;
              margin-top: 0.15rem;
            }

            .img-checked {
              width: 0.55rem;
              margin-top: 0.15rem;
            }

            .titulo {
              color: #fff;
              font-size: 8px;
              font-weight: 600;
              margin-left: 0.6rem;
            }
          }
        }
      }
    }
    
    .bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 24vw;
      margin-top: 1rem;

      .logo {
        display: flex;
        flex-direction: column;
        
        .logo-roda {
          width: 10rem;
        }

        .text-roda pre {
          font-size: 7px;
          color: #5B5A5A;
          font-weight: 400;
          margin-top: 0.6rem;
        }
      }

      .preco {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 13vw;
        height: 5rem;
        background: #1E4778;
        border-radius: 0.8rem;
        padding: 1rem;
        margin-top: 0.8rem;
        margin-left: 1rem;

        .descount {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          padding: 0 0.2rem;

          .percent {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            background: #6796CF;
            padding: 0.1rem 0.35rem;
            border-radius: 0.5rem;
            
            p {
              font-size: 11.5px;
              color: #254D7D;
              font-weight: 800;
            }
          }
            
          .valor-descont {
            font-size: 11px;
            color: #fff;
            font-weight: 600;
            text-decoration-line: line-through;
          }
            
          .valor-total {
            font-size: 11px;
            color: #fff;
            font-weight: 600;
          }
        }

        .final-valor {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 0.2rem;

          .valor-descont {
            font-size: 18px;
            color: #6796CF;
            font-weight: 800;
          }
            
          .valor-total {
            font-size: 11px;
            color: #fff;
            font-weight: 600;
          }
        }
      }
    }
  }

`;


export const Complemento = styled.div`
  content: "";
  width: 100%;
  background: #FFFFFF;

  ${props => {
    return `height: ${props?.height}px;`;
  }}
`